import React, {useEffect, useState} from 'react';
import {Button, Checkbox, DatePicker, Form, Input, InputNumber, Select} from "antd";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import GetUsersFullName from "../UserManagement/GetUsersFullName";
import locale from "antd/es/date-picker/locale/fa_IR";
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import {getFilterPalletStatus} from "../../microComponents/tablePages/getFilterPalletStatus";
import {allowLoadJson} from "../../helper/jsons/activatedJson";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {toast} from "react-toastify";
import Pallet from "../../http_request/Model/pallet/Pallet";
import Title from "../../microComponents/elements/Title";

const {RangePicker} = DatePicker;

const ReportBox = ({pageName, apiAddress, title}) => {
    const [loading, setLoading] = useState(false);
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);
    const [locationList, setLocationList] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const [filterPalletStatus, setFilterPalletStatus] = useState([]);
    const [palletStatusLoading, setPalletStatusLoading] = useState(false);
    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);

    const [form] = Form.useForm();


    useEffect(() => {
        getFilterQcStatus(setQcStatusList, setQcStatusLoading)
        GetUsersFullName(setUserList, setUserLoading)
        getFilterProductLine(setFilterProductLine, setProductLineLoading)
        GetProductList(setProductList, setProductListLoading)
        getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)
        getFilterLocation(setLocationList, setLocationLoading)
        getFilterPalletStatus(setFilterPalletStatus, setPalletStatusLoading)
        getFilterBranch(setFilterBranch, setBranchLoading)


    }, []);


    const onFinish = (values) => {

        Object.entries(values).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                values[key] = JSON?.stringify(value)
            }
            if (value === undefined) {
                delete values[key];
            }
        });


        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            },
            success: (data) => {
                 const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            },
            error: ({error}) => {
                toast.error(error.data.message);
            },
            final: (data) => {
                setLoading(data);
            },
        }).addParams({...values}, true).getReport(apiAddress);
    }
    const onFinishFailed = (x) => {
        console.log(x)
    }
    return (<div className="p-3">
        <Title children={title}/>
        <Form form={form}
              name="basic"
              layout='vertical'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{Details: false, Enters: false, Exits: false}}
        >
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-5 mt-10'>

                {(pageName === "oldInventory" || pageName === "EntryReport") && <Form.Item
                    name="RequiredDate"
                    label="تاریخ مدنظر"
                    rules={[{
                        required: true, message: 'لطفا تاریخ مدنظر را وارد کنید!',
                    },]}
                >
                    <DatePicker className="w-full"
                                locale={{
                                    ...locale, lang: {
                                        ...locale.lang, ok: "تایید",
                                    }
                                }}
                                popupClassName='datePickerBtn'

                                format="YYYY-MM-DD HH:mm"

                        // onOk={(e) => {
                        //     form.setFieldValue("RequierdData", e)
                        //     form.setFieldValue("ToCreated", e ? e[1] : '')
                        // }}

                    />


                </Form.Item>}
				

                {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") && <Form.Item
                    name="locations"
                    label="موقعیت"
                    rules={[{
                        required: (pageName === "inventory" || pageName === "oldInventory"),
                        message: 'لطفا موقعیت را وارد کنید!',
                    },]}

                >
                    <Select mode="multiple"
                            loading={locationLoading}
                            filterOption={(input, option) => {
                                return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                            }}
                            optionFilterProp='label'
                            options={locationList}/>


                </Form.Item>}
                

				{(pageName === "batchHistory" || pageName === "palletEntry" || pageName === "productSeries") &&
                    <Form.Item
                        name="fromCreated"
                        label="از تاریخ"
                    >
                        <DatePicker className="w-full"
                                    locale={{
                                        ...locale, lang: {
                                            ...locale.lang, ok: "تایید",
                                        }
                                    }}
                                    popupClassName='datePickerBtn'

                                    format="YYYY-MM-DD HH:mm"

                                    onOk={(e) => {
                                        form.setFieldValue("RequierdData", e)
                                        // form.setFieldValue("ToCreated", e ? e[1] : '')
                                    }}

                        />


                    </Form.Item>}
                {(pageName === "batchHistory" ||  pageName === "palletEntry" || pageName === "productSeries") &&
                    <Form.Item
                        name="ToCreated"
                        label="تا تاریخ"
                    >
                        <DatePicker className="w-full"
                                    locale={{
                                        ...locale, lang: {
                                            ...locale.lang, ok: "تایید",
                                        }
                                    }}
                                    popupClassName='datePickerBtn'

                                    format="YYYY-MM-DD HH:mm"

                                    onOk={(e) => {
                                        form.setFieldValue("ToCreated", e)
                                        // form.setFieldValue("ToCreated", e ? e[1] : '')
                                    }}

                        />


                    </Form.Item>}

                {(pageName === "batchHistory" || pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry" || pageName === "productSeries") &&
                    <Form.Item
                        name="product"
                        label="کالا"
                        // rules={[{
                        //     required: true, message: 'لطفا کالا را وارد کنید!',
                        // },]}

                    >


                        <Select showSearch mode="multiple"
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}

                                loading={productListLoading}
                                options={productList}/>
                    </Form.Item>}
                {(pageName === "batchHistory" || pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry" || pageName === "productSeries") &&
                    <Form.Item


                        name="brand"
                        label="برند">
                        <Select mode="multiple"
                                loading={filterDetailsListLoading}
                                filterOption={(input, option) => {

                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())

                                }}
                                optionFilterProp='label'

                                options={filterDetailsList?.brand}/>


                    </Form.Item>}


                
                {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") && <Form.Item


                    name="unitMeasurement"
                    label="واحد اندازه گیری">
                    <Select mode="multiple"
                            loading={filterDetailsListLoading}
                            filterOption={(input, option) => {

                                return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())

                            }}
                            optionFilterProp='label'

                            options={filterDetailsList?.unitMeasurement}/>


                </Form.Item>}
                {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") && <Form.Item


                    name="type"
                    label="نوع کالا">
                    <Select mode="multiple"
                            loading={filterDetailsListLoading}
                            filterOption={(input, option) => {

                                return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())

                            }}
                            optionFilterProp='label'

                            options={filterDetailsList?.type}/>


                </Form.Item>}
                
                {(pageName === "inventory" || pageName === "oldInventory") && <Form.Item
                    name="qcStatus"
                    label="وضعیت کالا"


                >
                    <Select mode="multiple"
                            loading={qcStatusLoading}
                            filterOption={(input, option) => {
                                return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                            }}
                            optionFilterProp='label'
                            options={qcStatusList}/>


                </Form.Item>}

     


                
                
                
             

                {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") && <Form.Item
                    name="palletStatus"
                    label=" وضعیت شناسه"


                >
                    <Select

                        mode="multiple"
                        loading={palletStatusLoading}
                        filterOption={(input, option) => {
                            return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                        }}
                        optionFilterProp='label'
                        options={filterPalletStatus}/>


                </Form.Item>}
                
  

                {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") &&
                    <Form.Item name="consumerPriceRials" label="قیمت"
                    >

                        <InputNumber className='w-full'
                                     formatter={value => `  ${value} `.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        />

                    </Form.Item>}



                {(pageName === "inventory" || pageName === "oldInventory") && <Form.Item
                    name="allowLoad"
                    label="جابجایی"
                    // rules={[{
                    //     required: true, message: 'لطفا بارگیری را وارد کنید!',
                    // },]}

                >
                    <Select options={allowLoadJson}/>
                </Form.Item>}


                <div className="flex items-center justify-between">
                    {(pageName === "inventory" || pageName === "oldInventory" || pageName === "palletEntry") &&
                        <Form.Item label="شامل جزییات" name="Details" valuePropName="checked"
                        >
                            <Checkbox/>
                        </Form.Item>}

                    {(pageName === "palletEntry") && <><Form.Item
                        label=" خروج"
                        name="Exits"
                        valuePropName="checked"

                    >
                        <Checkbox/>
                    </Form.Item>
                        <Form.Item
                            label=" ورود"
                            name="Enters"
                            valuePropName="checked"

                        >
                            <Checkbox/>
                        </Form.Item></>
                    }
                </div>
            </div>
            <Form.Item>
                <div className='gap-2 flex justify-end items-center'>

                    <Button loading={loading} htmlType="submit" className='defBtn blueBtn'>
                        ثبت
                    </Button>
                </div>
            </Form.Item>
        </Form>
    </div>);
};

export default ReportBox;